import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { boundActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import { formatFlightSearchDisplayText, type FlightSearchDisplayTextParams } from './formatFlightSearchDisplayText'

export function buildFlightSearchSubmittedActivityEntry(params: FlightSearchDisplayTextParams): TripPlannerSurfaceActivityEntry {
  return {
    kind: 'flight_search_submitted',
    label: 'Searched flights',
    displayText: boundActivityDisplayText(formatFlightSearchDisplayText(params)),
    sourcePath: 'trip_planner.search.flight',
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
  }
}
